/**
 *
 * Asynchronously loads the component for HistoryPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
